import React from 'react';

export const InactiveCheckIcon = () => {
    return (
        <svg
            width='32'
            height='32'
            viewBox='0 0 32 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clip-path='url(#clip0_8243_20191)'>
                <rect width='32' height='32' rx='16' fill='#F2F4F7' />
                <circle cx='16' cy='16' r='5' fill='white' />
            </g>
            <defs>
                <clipPath id='clip0_8243_20191'>
                    <rect width='32' height='32' rx='16' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};
